import { useCallback, useRef } from 'react';

export const useDebounced = <T>(
  callback: (arg: T) => void,
  timeout = 300,
  deps: any[]
) => {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  return useCallback(
    (arg: T) => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => {
        callback(arg);
      }, timeout);
    },
    [callback, timeout, ...deps]
  );
};
